import { Box, Flex } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Button } from "components";
import { CreditOptionsResponse, CreditResponse } from "types";

import CreditTabs from "../credit/tabs";

interface PreviousCreditRequestDetailProps {
  credit: CreditResponse;
  options: CreditOptionsResponse;
  navigateToCurrentRequest: () => void;
}

export const PreviousCreditRequestDetail = ({
  credit,
  options,
  navigateToCurrentRequest,
}: PreviousCreditRequestDetailProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        style={{
          backgroundColor: "var(--mantine-color-gray-1)",
          borderRadius: 8,
          padding: 16,
        }}
      >
        <CreditTabs credit={credit} options={options} readOnly />

        <Flex justify="flex-start" mt="lg" mb="md">
          <Button
            variant="subtle"
            color="var(--mantine-color-gray-7)"
            leftSection={<IconArrowLeft size={16} />}
            onClick={navigateToCurrentRequest}
          >
            {t("credit.current")}
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};
